import { render, staticRenderFns } from "./Senior.vue?vue&type=template&id=0fb3c705&"
import script from "./Senior.vue?vue&type=script&lang=js&"
export * from "./Senior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports